import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { personnelApi } from './personnelApi';

// Sidebar entry for HR Personnel; shown only when the server grants access. Badge = credential alerts.
const PersonnelNavItem = () => {
  const { user } = useSelector((state) => state.auth);
  const eligible = user?.role === 'admin' || user?.role === 'adminStaff';
  const [mode, setMode] = useState(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!eligible) return undefined;
    let alive = true;
    personnelApi
      .access()
      .then((a) => {
        if (!alive) return null;
        setMode(a.mode);
        return a.mode ? personnelApi.alerts().then((r) => alive && setCount(r.total || 0)) : null;
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [eligible]);

  if (!mode) return null;
  return (
    <li className="nav_link">
      <NavLink key="personnel" to="/personnel" activeClassName="link-name-active">
        <i className="fas fa-id-card" style={{ color: '#FEFFFF', fontSize: '24px' }}></i>
        <span className="link_name">
          HR Personnel
          {count > 0 && (
            <span
              title="Credential expiration alerts"
              style={{ background: '#dc2626', color: '#fff', borderRadius: 10, padding: '0 7px', marginLeft: 6, fontSize: 12 }}
            >
              {count}
            </span>
          )}
        </span>
      </NavLink>
    </li>
  );
};

export default PersonnelNavItem;
